// "04", "10", "137": the course designs pad small counts to two digits.
export function pad(n: number | undefined | null) {
  if (n === undefined || n === null) return "—";
  return n < 10 ? String(n).padStart(2, "0") : n.toLocaleString();
}

// Row wrapper for DataTable: rows stay on the page background and only
// tint on hover.
export const rowClass = "hover:bg-black/[0.02]";
